/* 売り切れ時のCTA文字だけを変更 */
(function () {
  'use strict';

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;

    // 購入可能なカラー・存在しない組み合わせは元テーマに任せる
    if (!variant || variant.available) return;

    var root = event.target;
    var forms = root.matches('form.ProductForm')
      ? [root]
      : root.querySelectorAll('form.ProductForm');

    Array.prototype.forEach.call(forms, function (form) {
      var script = form.querySelector('[data-stock-labels]');
      var button = form.querySelector('.ProductForm__AddToCart');

      if (!script || !button) return;

      var statuses;

      try {
        statuses = JSON.parse(script.textContent);
      } catch (error) {
        return;
      }

      var status = statuses[String(variant.id)];

      if (status === 'Coming Soon') {
        button.textContent = 'COMING SOON';
      } else if (status === 'Restock Soon') {
        button.textContent = 'RESTOCK SOON';
      }

      // 未設定の場合は、元テーマが表示したSOLD OUTを維持
    });
  });
})();